import { Component, inject } from '@angular/core';
import { NgbPopover, NgbDropdown, NgbDropdownToggle, NgbDropdownMenu } from '@ng-bootstrap/ng-bootstrap';
import { IccImportHistoryComponent } from '../icc-import-history/icc-import-history.component';
import { IccPharmacyImportsService } from '../../../core/services/icc/icc-pharmacy-imports.service';
import { ImportNavComponent } from '../../../shared/components/import-nav/import-nav.component';
import { DecimalPipe, TitleCasePipe, DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgSelectComponent } from '@ng-select/ng-select';
import { PaginationHeaderComponent } from '../../../shared/components/pagination-header/pagination-header.component';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { PaginationComponent } from '../../../shared/components/pagination/pagination.component';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-icc-import-pharmacies-history',
  templateUrl: '../icc-import-history/icc-import-history.component.html',
  imports: [ImportNavComponent,
    FormsModule,
    NgSelectComponent,
    PaginationHeaderComponent,
    FaIconComponent,
    NgbPopover,
    NgbDropdown,
    NgbDropdownToggle,
    NgbDropdownMenu,
    PaginationComponent,
    MatProgressSpinner,
    DecimalPipe,
    TitleCasePipe,
    DatePipe]
})
export class IccImportPharmaciesHistoryComponent extends IccImportHistoryComponent {
  private pharmacyImportsService = inject(IccPharmacyImportsService);

  pageTitle = 'Pharmacy Import History';

  getImports(paging, filters) {
    return this.pharmacyImportsService.getList(paging, filters);
  }

  prepareImportResults(data) {
    return data.pharmacyImports;
  }

  getImport(importId) {
    return this.pharmacyImportsService.get(importId);
  }

  updateImport(importId, name) {
    return this.pharmacyImportsService.update(importId, name);
  }

  cancelImport(importId) {
    return this.pharmacyImportsService.cancel(importId);
  }
}
